const appCmdQueue = [];


const renderFunctionNamesToImportCall = {
    'setupNodeForStaffSelection': () => import('./ProposalStaffCharges/Proposal.js'),
    'renderUtilisationWidget': () => import('./Utilisation/Utilisation.tsx'),
    'bootstrapStaffAndRoleLists': () => import('./ProposalStaffCharges/Proposal.js'),
    'setupNodeForRoleSelection': () => import('./ProposalStaffCharges/Proposal.js'),
    'renderStaffRoleSelectionForNode': () => import('./ProposalStaffCharges/Proposal.js'),
    'renderProposalCharges': () => import('./ProposalStaffCharges/Proposal.js'),
    'loadTimeSheetComponents': () => import('./TimeEntries.js'),
    'renderProposalSubmissionWidget': () => import('./ProposalSubmission/ProposalSubmission.tsx'),
    'renderStaffRoleUtilisationFilterWidget': () => import('./StaffUtilisationFilter.js'),
    'renderTransmittalItemSelectionWidget': () => import('./Transmittal/TransmittalBase.tsx'),
    'renderHoursAnalysisReportToHtmlNode': () => import('./HoursAnalaysisReport/HoursAnalysisReport.tsx')
}

const renderFunctionNames = Object.keys(renderFunctionNamesToImportCall);

for (const fName of renderFunctionNames) {
    window[fName] = window[fName] || function (...args) {
        appCmdQueue.push([fName, args])
    }
}
console.log('setup render functions');
document.addEventListener('DOMContentLoaded', async () => {

    console.log('dom content loaded call render functions');
    console.log(appCmdQueue.length);
    let i = 0;
    for (const [funcName, args] of appCmdQueue) {
        try {
            await renderFunctionNamesToImportCall[funcName]();
            i++;
            console.log(i);
            // @ts-expect-error dynamic function call
            window[funcName](...args);
        } catch (e) {
            console.log('failed to call', funcName, args, e);
        }
    }
    console.log(appCmdQueue.length);


})


export * from './Components/Utils.ts'


// export { predefinedRangesPlugin } from './Utilities/dateRangePlugin.js'
// export {
//     getAttachedFilesWithHashes
// } from './Components/Utils.ts'
